import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import PagePathMovementForm from '../components/PagePathMovementForm';
import { PrimaryButton, SecondaryButton } from '../../../components/Buttons';

import { useSelector, useDispatch } from 'react-redux';
import { updateSubTree, hidePathMovementDialog } from "../actions";
import { getLinkParentUrl } from '../../../components/Utils';

const PageMovementDialog = ({ history }) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const isVisible = useSelector(state => state.staticPage.showPathMovementDialog);
  const linkData = useSelector(state => state.staticPage.currentLinkData);
  const treeLinks = useSelector(state => state.staticPage.currentTreeLinks);

  const onHide = useCallback(() => {
    dispatch(hidePathMovementDialog());
  }, [dispatch]);

  const onSave = useCallback(() => {
    const model = formRef.current ? formRef.current.getModel() : null;
    if (!model) {
      return;
    }
    dispatch(updateSubTree(model, () => {
      onHide();
      history.replace(getLinkParentUrl(model.to));
    }));
  }, [dispatch, history, onHide]);

  if (!isVisible) {
    return null;
  }

  console.log('PageMovementDialog.render()', { isVisible, linkData, treeLinks, history });
  // header
  const header = (
    <div className="bg-secondary-" style={{margin: '-1em', padding: '1em'}}>
      <h3 className="no-margin">{`Seite verschieben: ${linkData.label}`}</h3>
    </div>
  );
  // footer
  const footer = (
    <div className="alg-right w3-light-grey" style={{margin: '-0.571em -1em', padding: '1em'}}>
      <PrimaryButton className="margin-lft" onClick={onSave}>
        {'Speichern'}
      </PrimaryButton>
      <SecondaryButton className="margin-lft" onClick={onHide}>
        {'Abbrechen'}
      </SecondaryButton>
    </div>
  );

  return (
    <Dialog
      header={header}
      footer={footer}
      iconsTemplate={null}
      visible
      style={{width: '600px'}}
      modal={true}
      onHide={onHide}
    >
      <PagePathMovementForm
        ref={formRef}
        model={linkData}
        treeLinks={treeLinks}
      />
    </Dialog>
  );
};

PageMovementDialog.propTypes = {
  history: PropTypes.object.isRequired,
};

export default PageMovementDialog;

